import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeader } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { PaginationService } from 'projects/Administration/src/app/services/pagination.service';
import { PagerData } from 'projects/Administration/src/app/business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Filter } from 'projects/Administration/src/app/business-entities/Filter';
import { CheckInDealersModal } from 'projects/Administration/src/app/business-entities/checkin-user-model';
import { CheckinUserService } from 'projects/Administration/src/app/business-services/checkin-user.service';
import { CheckInTraversalLogComponent } from '../checkin-traversal-log/check-in-traversal-log/check-in-traversal-log.component';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { CheckInUsageReport } from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-checkin-dealer-details',
  templateUrl: './checkin-dealer-details.component.html',
  styleUrl:'./checkin-dealer-details.component.css'
})
export class CheckinDealerDetailsComponent implements OnInit {
  checkInDealerList: CheckInDealersModal[];
  dealerList = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;

  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  debounceTimer;
  dataList :CheckInDealersModal []=[]; 
  @Input() dealerId;
  @Input() dealerName;
  @Input() selectedDate;
  @Input() appointmentCheckInStatus;
  @Input() checkInUsageReportStatus;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  showSmsFailureColumns: boolean = false;
  showSmsSentDateTime: boolean = false;
  showCheckInDateTime: boolean = false;
  
  constructor(
    private spinner: NgxSpinnerService,
    private activeModal: NgbActiveModal,
    private pagerService: PaginationService,
    private checkInUserService: CheckinUserService,
    private modalService: NgbModal,
    private excelService: ExcelService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.checkInUserService.checkinDealerListRequest.startRecordNumber = 0;
    this.dealerList = this.checkInUserService.dealerList;
    this.checkInDealerList = [];
    this.checkInUserService.checkinDealerListRequest.dealerId = this.dealerId;
    this.checkInUserService.checkinDealerListRequest.selectedDate = this.selectedDate;
    this.showSmsFailureColumns = this.appointmentCheckInStatus === CheckInUsageReport.SmsNotSentAppointments;
    this.showSmsSentDateTime = (this.appointmentCheckInStatus === CheckInUsageReport.CheckInCompletedAppointments 
      || this.appointmentCheckInStatus === CheckInUsageReport.CheckInNotCompletedAppointments
      || this.appointmentCheckInStatus === CheckInUsageReport.CheckInNotStartedAppointments
      || this.appointmentCheckInStatus === CheckInUsageReport.SmsSentAppointments
    );
    this.showCheckInDateTime = (this.appointmentCheckInStatus === CheckInUsageReport.CheckInCompletedAppointments
      || this.appointmentCheckInStatus === CheckInUsageReport.SmsSentAppointments
      || this.appointmentCheckInStatus === CheckInUsageReport.SmsNotSentAppointments
      || this.appointmentCheckInStatus === CheckInUsageReport.TotalAppointments
      || this.appointmentCheckInStatus === CheckInUsageReport.CheckInCompletedWithoutSmsAppointments
    );
    this.checkInUserService.checkinDealerListRequest.appointmentCheckInStatus = this.appointmentCheckInStatus;
    this.getCheckInDealerList();
  }

  onRefreshClick(){
    this.checkInDealerList = [];
    this.getCheckInDealerList();  
  }

  async getCheckInDealerList() {
    this.spinner.show();
    await this.checkInUserService
      .getCheckInDealerList(this.checkInUserService.checkinDealerListRequest)
      .then(
        (response) => {
          this.spinner.hide();
          this.checkInDealerList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            if(this.checkInDealerList?.length > 0){
              this.checkInDealerList?.forEach(x => {
                if(x?.bookedDate){
                  x.bookedDate = x.bookedDate ? new Date(x.bookedDate + 'Z') : null;
                }
                if(x?.checkInDate){
                  x.checkInDate = x.checkInDate ? new Date(x.checkInDate + 'Z') : null;
                }
              })
            }
            this.totalCount =
              this.checkInDealerList.length > 0
                ? this.checkInDealerList[0].totalCount
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.checkInDealerList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  loadMoreData(event){
    this.debounceFunction(()=>this.onScrollDown(event),200);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.checkInDealerList?.length) {
      this.checkInUserService.checkinDealerListRequest.startRecordNumber = this.checkInDealerList.length
      this.getCheckInDealerList();
    }
  }

  ViewTraversalLog(item:any){
    if(item.isCheckInStarted){
      const modalref = this.modalService.open(CheckInTraversalLogComponent, { size: 'lg', windowClass: 'pop-wid1200' });
      modalref.componentInstance.workOrderNo = item?.workOrderNo;
    }
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
  // Export functionality
  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
      this.spinner.show();
      const excelData = this.mapDataForExport();
      this.spinner.hide();
      this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblCheckInUsage')}_${this.dealerName}`);
  }
  
  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
      this.spinner.show();
      const pdfData = this.mapDataForExport();
      const doc = new jsPDF('landscape');
      autoTable(doc, {
        head: [this.getHeadersForExport()],
        body: pdfData.map(row => Object.values(row)),
        margin: { top: 10, left: 10, right: 10, bottom: 10 },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak' },
        headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
        columnStyles: {
          0: { cellWidth: 15, halign: 'center' },
          1: { cellWidth: 30, halign: 'left' },
          2: { cellWidth: 30, halign: 'right' },
          3: { cellWidth: 25, halign: 'right' },
          4: { cellWidth: 30, halign: 'right' },
          5: { cellWidth: 30, halign: 'right' },
          6: { cellWidth: 35, halign: 'right' },
          7: { cellWidth: 30, halign: 'right' },
          8: { cellWidth: 25, halign: 'right' },
          9: { cellWidth: 25, halign: 'right' },
        },
      });
      doc.save(`${this.translate.instant('lblCheckInUsage')}_${this.dealerName}.pdf`);
      this.spinner.hide();
  }
  
  private async exportData(): Promise<void> {
    this.spinner.show();
    this.checkInUserService.checkinDealerListRequest.isExport = true;
    await this.checkInUserService.getCheckInDealerList(this.checkInUserService.checkinDealerListRequest).then((res) => {
      if (!res || res.responseObject.length === 0) {
        this.toastr.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.checkInUserService.checkinDealerListRequest.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblCustomer')]: item.customerName,
      [this.translate.instant('lblWoNo')]: item.workOrderNo,
      [this.translate.instant('lblCheckInDate')]: item.checkInDate ? this.datePipe.transform(new Date (item.checkInDate+'Z'),'short') : '',
      [this.translate.instant('lblBookedDate')]: item.bookedDate ? this.datePipe.transform(new Date(item.bookedDate+'Z'),'short') : '',
      [this.translate.instant('lblCustomerMobile')]: item.customerMobile,
      [this.translate.instant('lblVirtualCheckin')]: item.virtualCheckin ? 'Yes' : 'No'
    }));
  }
  
  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblCustomer'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblCheckInDate'),
      this.translate.instant('lblBookedDate'),
      this.translate.instant('lblSMSFailureReason'),
      this.translate.instant('lblSMSQueueStatus'),
      this.translate.instant('lblCustomerMobile'),
      this.translate.instant('lblVirtualCheckin')
    ];
  }
}
